<template>
    <div>
        <div class="m-5 text-center mt-5">
            <div class="card">
                <div class="d-flex justify-content-left align-items-center pt-3 mb-3">
                    <b-button variant="success" class="ml-3" @click="atualizarLista">
                        <i class="fas fa-play mr-1"></i> Atualizar
                    </b-button>
                    <div class="d-flex align-items-center ml-4">
                        <span><strong><span style="font-size: 25px;">TOTAL: {{ querys.length }}</span></strong>  registros</span>
                    </div>
                </div>
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">datname</th>
                            <th scope="col">pid</th>
                            <!-- <th scope="col">application_name</th> -->
                            <th scope="col">client_addr</th>
                            <th scope="col">query_start</th>
                            <th scope="col">wait_event_type</th>
                            <th scope="col">wait_event</th>
                            <th scope="col">state</th>
                            <th scope="col">query</th>
                            <th scope="col">Ações</th>
                        </tr>
                    </thead> 
                    <tbody>
                        <tr v-for="(query, index) in querys" :key="index" :style="backgroundDiv(query)">
                            <td>{{ query.datname }}</td>
                            <td>{{ query.pid }}</td>
                            <!-- <td>{{ query.application_name }}</td> -->
                            <td>{{ query.client_addr }}</td>
                            <td>{{ query.query_start }}</td>
                            <td>{{ query.wait_event_type }}</td>
                            <td>{{ query.wait_event }}</td>
                            <td>{{ query.state }}</td>
                            <td>{{ query.query }}</td>
                            <th scope="row">
                                <button class="btn btn-danger mr-2" @click="excluirRegistro(query.pid)"><i
                                        class="fa fa-trash"></i></button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    computed: {
        querys() { 
            let arrQuery = this.$store.getters['painel/getMonitoramento']

            this.verificaExcluirRegistro(arrQuery)

            arrQuery = arrQuery.map(element => {
                if (element.query == "SELECT datname, pid, application_name, client_addr, query_start, wait_event_type, wait_event, state, query from pg_stat_activity where application_name = '' and datname is not null order by query_start")
                    return {}

                return element
            })

            let index = arrQuery.indexOf({})

            arrQuery.splice(index, 1)

            return arrQuery
        }
    },
    created() {
        this.$store.dispatch('painel/getMonitoramento')
        this.setupTimer();
    },
    methods: {
        backgroundDiv(query){
            const palavra = query.wait_event_type ? query.wait_event_type : ''
            console.log(palavra)
            
            if(palavra && palavra.toLowerCase().includes("lock")){
                return 'background: linear-gradient(45deg, #0a0015, #36006f); color: #fff;';
            }

            const queryStart = query.query_start;

            if(queryStart) {
                let [datePart, timePart] = queryStart.split(" ");
        
                // Expressão que extrai e limita os milissegundos para 3 dígitos e adiciona offset correto
                timePart = timePart.replace(/^(\d{2}:\d{2}:\d{2})\.(\d{3})\d*(-\d{2})$/, '$1.$2$3:00');
                
                let isoString = `${datePart}T${timePart}`;

                let startDate = new Date(isoString);
                if (isNaN(startDate)) {
                    console.warn("Data inválida:", isoString); 
                    return '';
                }

                let now = new Date();
                let diffMinutes = (now - startDate) / 1000 / 60;

                // Verifica se passou mais de 5 minutos
                if (diffMinutes > 5) {
                    return 'background: linear-gradient(45deg, #940000, #ff0000); color: #fff;';
                }
            }

            return '';
        },
        parseDate(dateString) {
            if (dateString.includes('.')) {
                // Caso a data tenha milissegundos e fuso horário, ajusta para ISO 8601
                const [datePart, timePart] = dateString.split(' ');
                const [time, millisOffset] = timePart.split('-');
                const [timeWithoutMillis, millis] = time.split('.');
                return new Date(`${datePart}T${timeWithoutMillis}.${millis || '000'}-03:00`);
            } else {
                // Caso a data não tenha milissegundos e fuso horário
                return new Date(dateString.replace(' ', 'T') + 'Z');
            }
        },

        verificaExcluirRegistro(registros) {
            registros.forEach(element => {
                const currentDate = new Date();
                const horaAtual = currentDate.toLocaleString('sv-SE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                }).replace(' ', 'T');

                const date1 = new Date(horaAtual.replace('T', ' '))
                const date2 = new Date(element.query_start)

                const differenceInMilliseconds = date1 - date2;
                const differenceInMinutes = differenceInMilliseconds / (1000 * 60);

                console.log(element.pid + ' - ' + differenceInMinutes)

                if (differenceInMinutes >= 20) {
                    // console.log('Deletar Registro')
                    this.$store.dispatch('painel/deleteRegistro', { data: element.pid })
                } else {
                    console.log('Data01 não é 20 minutos superior a Data02');
                }
            })

            console.log('----------------')
        },

        atualizarLista() {
            this.$store.dispatch('painel/getMonitoramento')
        },

        setupTimer() {
            // Executar a cada 1 minuto (60000 milissegundos)
            this.timer = setInterval(() => {
                this.$store.dispatch('painel/getMonitoramento')
            }, 30000);
        },
        // Limpar o temporizador ao destruir o componente
        beforeDestroy() {
            clearInterval(this.timer);
        },

        excluirRegistro(registro) {
            this.$swal.fire({
                title: 'Excluir o registro?',
                text: `Deseja finalizar o registro?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirmar'
            }).then(result => {
                if (result.dismiss !== 'cancel' && result.dismiss !== 'backdrop') {
                    this.$store.dispatch('painel/deleteRegistro', { data: registro }).then((response) => {


                        this.$swal.fire({
                            title: 'Excluído com sucesso!',
                            text: 'O registro foi finalizado com sucesso',
                            icon: 'success',
                            timer: 1000
                        })
                    }).catch((error) => {
                        console.log(error)
                        this.$swal.fire({
                            title: 'Ooops!',
                            text: 'Ocorreu um erro, tente novamente!',
                            icon: 'warning'
                        })
                    })
                }
            })
        }

    }
}
</script>